import React from "react";
import { Text } from "../subComponents/text";
import { Img } from "../subComponents/img";
import { NavLink } from "react-router-dom";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <>
      <div className="outer_footer_section">
        <section className="footer_section">
          {/* footer social media start from here */}
          <div className="footer_top_section">
            <Link to={"/"}>
              <div className="footer_logo">
                <Img
                  src={"/assets/images/sitelogo.png"}
                  alt={"logo Tube Flex India"}
                />
              </div>
            </Link>

            <div className="footer_social_media_container">
              <h5>Connect With Us</h5>
              <div className="footer_social_medias">
                <Link
                  to={"https://www.linkedin.com/in/tube-flex-india-56303a3b8/"}
                  target="blank"
                >
                  <div className="social_media">
                    <Img
                      src={"/assets/images/Home/icons/linkedin.png"}
                      alt={"linkedin"}
                    />
                  </div>
                </Link>
                {/* <Link to={"#"} target="blank">
                  <div className="social_media">
                    <Img
                      src={"/assets/images/Home/icons/facebook.png"}
                      alt={"facebook"}
                    />
                  </div>
                </Link> */}
                <Link
                  to="https://wa.me/919996970583?text="
                  target="_blank"
                  rel="noreferrer"
                >
                  <div className="social_media">
                    <Img
                      src={"/assets/images/Home/icons/whatsapp.png"}
                      alt={"whatsapp"}
                    />
                  </div>
                </Link>
                {/* <Link to={"#"} target="blank">
                  <div className="social_media">
                    <Img
                      src={"/assets/images/Home/icons/insta.png"}
                      alt={"instagram"}
                    />
                  </div>
                </Link> */}
              </div>
            </div>
          </div>
          {/* footer social medai close from here */}

          {/* footer navigation start from here */}
          <div className="footer_navigation_container">
            {/* footer card one start from here */}
            <div className="footer_card">
              <div>
                <div className="first_link_footer">
                  <div>
                    <Text
                      text={"Discover Tube Flex India"}
                      className={"footer_heading"}
                    />
                    <br />
              <div className="footer_menu_container">
                      <NavLink to={"/"} style={{ textDecoration: "none" }}>
                      <Text text={"Home"} style={{color:"white",fontSize:"0.785rem"}} />
                    </NavLink>
                    <NavLink
                      to={"/about-us/"}
                      style={{ textDecoration: "none" }}
                    >
                      <Text text={"About Us"} style={{color:"white",fontSize:"0.785rem"}} />
                    </NavLink>
                    <NavLink to={"/blogs/"} style={{ textDecoration: "none" }}>
                      {" "}
                      <Text text={"Blog"} style={{color:"white",fontSize:"0.785rem"}} />
                    </NavLink>

                    <NavLink to={"/certification/"} style={{ textDecoration: "none" }}>
                      {" "}
                      <Text text={"Certification"} style={{color:"white",fontSize:"0.785rem"}} />
                    </NavLink>
              </div>
                  </div>
                </div>
              </div>
            </div>
            {/* footer card one close from here */}

            {/* footer card two start from here */}
            <div className="footer_card">
              <div>
                <Text text={"Nylon Tube Assemblies"} className={"footer_heading"} />
                <br />
                <div className="footer_menu_container">
                 <Link
                  to="#"
                  style={{ textDecoration: "none" }}
                >
                  <Text text={"Brake & Clutch Fluid Lines	"} style={{color:"white",fontSize:"0.785rem"}} />
                </Link>
                <Link
                  to="#"
                  style={{ textDecoration: "none" }}
                >
                  <Text text={"Quick-Connect Assemblies"} style={{color:"white",fontSize:"0.785rem"}} />
                </Link>
                <Link
                  to={"#"}
                  style={{ textDecoration: "none" }}
                >
                  <Text text={"Vacuum & Emission Lines"} style={{color:"white",fontSize:"0.785rem"}} />
                </Link>
                <Link
                  to={"#"}
                  style={{ textDecoration: "none" }}
                >
                  <Text text={"Fuel Line Assemblies"} style={{color:"white",fontSize:"0.785rem"}} />
                </Link>
                </div>
              </div>
            </div>
            {/* footer card two close from here */}

            {/* footer card three start from here */}
            <div className="footer_card">
              <div>
                <Text
                  text={"Metal Tubes"}
                  className={"footer_heading"}
                />
                <br />
                <div className="footer_menu_container">
                <Link
                  to={"#"}
                  style={{ textDecoration: "none" }}
                >
                  <Text text={"Exhaust Gas Recirculation (ER) Tubes"} style={{color:"white",fontSize:"0.785rem"}} />
                </Link>
                <Link
                  to={"#"}
                  style={{ textDecoration: "none" }}
                >
                  <Text text={"High-Pressure Diesel Injection Pipes"} style={{color:"white",fontSize:"0.785rem"}} />
                </Link>
                <NavLink
                  to={"#"}
                  style={{ textDecoration: "none" }}
                >
                  <Text text={"Brake Line Tubing (Double Walled)"} style={{color:"white",fontSize:"0.785rem"}} />
                </NavLink>
                </div>
              </div>
            </div>
            {/* footer card three close from here */}

            {/* footer card four start from here */}
            <div className="footer_card">
              <div>
                <Text
                  text={"Manufacturing"}
                  className={"footer_heading"}
                />
                <br />
                <div className="footer_menu_container">
                <Link
                  to={"#"}
                  style={{ textDecoration: "none" }}
                >
                  <Text text={"	Precision Tube Bending "}  style={{color:"white",fontSize:"0.785rem"}}/>
                </Link>
                <Link
                  to={"#"}
                  style={{ textDecoration: "none" }}
                >
                  <Text text={"Tube Extrusion (Nylon/Plastic)"} style={{color:"white",fontSize:"0.785rem"}} />
                </Link>
                <Link
                  to={"#"}
                  style={{ textDecoration: "none" }}
                >
                  <Text text={"End-Forming & Flaring"} style={{color:"white",fontSize:"0.785rem"}} />
                </Link>
                </div>
              </div>
            </div>
            {/* footer card four close from here */}

            {/* footer card five start from here */}
            <div className="footer_card">
              <div>
                <Text text={"Support"} className={"footer_heading"}  />
                <br />
                <div className="footer_menu_container">
                <NavLink
                  to={"/terms-&-Condition/"}
                  style={{ textDecoration: "none" }}
                >
                  <Text text={"Terms & Condition"} style={{color:"white",fontSize:"0.785rem"}} />
                </NavLink>
                <NavLink
                  to={"/privacy-policy/"}
                  style={{ textDecoration: "none" }}
                >
                  <Text text={"Privacy Policy"} style={{color:"white",fontSize:"0.785rem"}} />
                </NavLink>
                <NavLink to={"/locate-us/"} style={{ textDecoration: "none" }}>
                  <Text text={"Locate Us"} style={{color:"white", fontSize:"0.785rem"}} />
                </NavLink>
                </div>
              </div>
            </div>
            {/* footer card five close from here */}
          </div>
          {/* footer navigation close from here */}
        </section>

        {/* footer copyright text start from */}
        <h6
          style={{
            textAlign: "center",
            fontSize: "0.75rem",
            padding: "1.4rem",
            // backgroundColor: "#000",
            color: "#fff",
            borderTop: "2px solid rgba(255, 255, 255, 0.075)",
          }}
        >
          Copyright 2026 -Tube Flex India is developed by alponix private limited
        </h6>
        {/* footer copyright text close from */}
      </div>
    </>
  );
};
export { Footer };
